import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { TextButton } from './TextButton';

export const TextButtonBridge = react2angular(TextButton, [
  'testId',
  'text',
  'type',
  'title',
  'disabled',
  'id',
  'classNames',
  'iconClass',
  'outlineOnly',
  'onClick'
]);
